import { useSensors, useSensor, PointerSensor } from '@dnd-kit/core';

export function useSortableConfig(activationDistance = 8) {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: activationDistance,
      },
    })
  );
}

